import type { ThemeConfig } from 'antd';

/** TNC Ant Design theme. Status colors in the transfer UI read these tokens. */
export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#52AE3F',
    colorLink: '#52AE3F',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    borderRadius: 6,
    fontFamily: "'Barlow', system-ui, -apple-system, sans-serif",
  },
  components: {
    Layout: {
      headerBg: '#fff',
      siderBg: '#fff',
    },
    Card: {
      borderRadius: 8,
    },
    Button: {
      borderRadius: 6,
    },
  },
};
